"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositButton = void 0;
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DepositButton = function (_a) {
    var t = _a.t, onClick = _a.onClick, color = _a.color;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
        react_1.default.createElement(ui_components_1.FixedButton, { maxWidth: "100%", onClick: onClick, color: color, text: "upper" }, t('deposit'))));
};
exports.DepositButton = DepositButton;
